import { motion } from "framer-motion";
import { MANIFESTO } from "@/data/content";
import { Reveal, Overline } from "./Reveal";

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal className="max-w-2xl mb-16">
          <Overline>Our Philosophy</Overline>
          <h2 className="font-serif-lux mt-5 text-4xl md:text-6xl leading-none tracking-tight">
            Interiors beyond <span className="text-gold-gradient italic">limitations.</span>
          </h2>
        </Reveal>

        <div className="divide-y divide-white/8 border-y border-white/8">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.no} delay={i * 0.05}>
              <div className="group grid md:grid-cols-12 gap-6 py-10 items-start hover:bg-[#0a0a0a] transition-colors duration-500 -mx-6 md:-mx-10 px-6 md:px-10" data-testid={`manifesto-${m.no}`}>
                <div className="md:col-span-2 font-serif-lux text-5xl md:text-6xl text-[#e7c15a]/30 group-hover:text-[#e7c15a] transition-colors duration-500">{m.no}</div>
                <h3 className="md:col-span-4 font-serif-lux text-2xl md:text-3xl text-[#fafafa] tracking-tight">{m.title}</h3>
                <p className="md:col-span-6 text-[#b8b8b8] leading-relaxed md:text-lg">{m.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
